import config from "config";

import ZoomTo from "components/ZoomTo";
import config_zoomto from "components/ZoomTo/config_zoomto";
import React from "react";
import geometryTools from "utils/geometryTools";
import ReactDOM from "react-dom/client";

import PhotoFrame from "components/commons/PhotoFrame";

const POPUP_TEMPATES = {
  "UAV Image Point": {
    title: "{SITENAME} ({DATETAKEN})",
    content: function(feature) {
      let graphic, attributes, content;
      graphic = feature.graphic;
      attributes = graphic.attributes;
      let imgUrl =
        config.fileSrvUrl +
        "File/uav?filename=" +
        attributes.FILE_.match(/(?<=UAV).*/)[0].substr(1);
      content = document.createElement("DIV");
      let root = ReactDOM.createRoot(content);
      setTimeout(() => {
        root.render(<PhotoFrame urlList={[imgUrl]} />);
      });
      return content;
    },
  },
};

class IdentifyManager {
  static mapViewPtr = null;
  static zoomToInstance = null;
  static mapViewProps = null;
  static enableIdentify = true;
  static mapViewComponent = null;
  static addPopupTemplate(layerTitle, template) {
    POPUP_TEMPATES[layerTitle] = template;
  }
  static initialHook(mapView, props, mapViewComponent) {
    let newProps = { ...props, mapView };
    IdentifyManager.mapViewComponent = mapViewComponent;
    IdentifyManager.mapViewPtr = mapView;
    let component = React.createElement(ZoomTo, newProps);
    IdentifyManager.zoomToInstance = new component.type(newProps);
    IdentifyManager.zoomToInstance.props = newProps;
    IdentifyManager.mapViewProps = newProps;

    mapView.on("click", IdentifyManager.handleMapPoint);
    IdentifyManager.slopeLayer = IdentifyManager.mapViewPtr.map.allLayers.find(
      (i) => i.title == "Man Made Slope"
    );
  }

  static async handleMapPoint(evt) {
    if (!IdentifyManager.enableIdentify) return;
    let hasPopup = await new Promise((r) => {
      setTimeout(() => r(IdentifyManager.mapViewPtr.popup.visible));
    });
    // if (hasPopup) return;
    let include = Object.keys(POPUP_TEMPATES)
      .map((i) =>
        IdentifyManager.mapViewPtr.map.allLayers.find((l) => l.title === i)
      )
      .filter((i) => !!i);
    let hitTestResult =
      include.length === 0
        ? { results: [] }
        : await IdentifyManager.mapViewPtr.hitTest(evt, { include });
    console.debug(hitTestResult);
    if (hitTestResult.results.length > 0) {
      hitTestResult = hitTestResult.results;
      let popupTemplate = { ...POPUP_TEMPATES[hitTestResult[0].layer.title] };
      hitTestResult.forEach((i) => (i.graphic.popupTemplate = popupTemplate));
      setTimeout(() =>
        IdentifyManager.mapViewPtr.popup.open({
          features: hitTestResult.map((i) => i.graphic),
          location: evt.mapPoint,
        })
      );
    } else {
      if (IdentifyManager.mapViewComponent.props.isSplitMapActivated) return;
      console.debug("IdentifyManager", evt);
      IdentifyManager.querySlopeInfo(evt);
    }

    // further discussion of IR42 popup template
    // IdentifyManager.mapViewPtr.hitTest(evt).then(function(response) {
    //   // console.log("attributes", response);
    //   // const result = response.results[0];
    //   // if (result && result.graphic) {
    //   const attributes = response?.results[0]?.graphic?.attributes;
    //   console.log("attributes", response, attributes);
    //   // }
    // });
  }

  static async querySlopeInfo(evt) {
    let slopeLayer = IdentifyManager.slopeLayer;
    if (slopeLayer && slopeLayer.visible) {
      let newScreenPt = { ...evt.screenPoint };
      newScreenPt.x += 10;
      let mapPt10PxOffset = IdentifyManager.mapViewPtr.toMap(newScreenPt);
      let meter10Px = Math.abs(mapPt10PxOffset.x - evt.mapPoint.x);
      let bufferedPt = await geometryTools.buffer(evt.mapPoint, meter10Px);
      let mmsSearchInfo = config_zoomto.GRAPHICAL_SEARCH_LIST.find(
        (i) => i.type === "mms"
      );
      setTimeout(() => {
        IdentifyManager.zoomToInstance.graphicSearchCallback(
          mmsSearchInfo,
          bufferedPt
        );
      });
      IdentifyManager.mapViewComponent.props.switchPanel(0);
    }
  }
}

export default IdentifyManager;
